import { createContext, useContext, useState } from "react";

/**
 * Holds the most recently parsed CV so that the CV modal can hand off
 * pre-filled fields to the /apply page without a page reload / query string.
 */
const CandidateContext = createContext(null);

export const CandidateProvider = ({ children }) => {
  const [parsedCV, setParsedCV] = useState(null); // { name, email, ..., skills, cv_text_preview }
  const [cvFilename, setCvFilename] = useState(null);
  const [cvText, setCvText] = useState(null);

  const consume = () => {
    const snapshot = { parsedCV, cvFilename, cvText };
    // one-shot: caller should hydrate its form then clear
    return snapshot;
  };

  const clear = () => {
    setParsedCV(null);
    setCvFilename(null);
    setCvText(null);
  };

  return (
    <CandidateContext.Provider
      value={{
        parsedCV,
        setParsedCV,
        cvFilename,
        setCvFilename,
        cvText,
        setCvText,
        consume,
        clear,
      }}
    >
      {children}
    </CandidateContext.Provider>
  );
};

export const useCandidate = () => {
  const ctx = useContext(CandidateContext);
  if (!ctx) throw new Error("useCandidate must be used within CandidateProvider");
  return ctx;
};
